import { TourDefinition } from '../models/guided-tour.model';

/**
 * The first-run walkthrough of the Agent Hub home screen. Auto-started once
 * per user (see AgentHomeChatComponent) and replayable from the What's New
 * modal. Anchors live as data-tour attributes in agenthome-chat.component.html;
 * steps whose anchor isn't rendered (permission-gated items) are auto-skipped.
 */
export const AGENT_HUB_TOUR: TourDefinition = {
  id: 'agent-hub-first-run',
  steps: [
    {
      title: 'Welcome to Agent Hub 👋',
      body: 'Your one place to put WatchGuard’s AI agents to work. ' +
        'Here’s a quick tour of the essentials — it takes about 30 seconds.',
    },
    {
      anchor: 'composer',
      title: 'Just ask',
      body: 'Type any question here and Agent Hub routes it to the best agent ' +
        'for the job. Type / to call a specific agent, or use the paperclip ' +
        'to attach a file.',
      placement: 'bottom',
    },
    {
      anchor: 'new-chat',
      title: 'Start a fresh chat',
      body: 'Spin up a clean conversation anytime — earlier sessions stay ' +
        'saved under Recents.',
      placement: 'right',
    },
    {
      anchor: 'agent-catalog',
      title: 'Meet the agents',
      body: 'Browse every available agent, each with ready-made quick chats ' +
        'to get you started fast.',
      placement: 'right',
    },
    {
      anchor: 'search-sessions',
      title: 'Find past work fast',
      body: 'Search all your sessions — or press Ctrl+K from anywhere.',
      placement: 'right',
    },
    {
      anchor: 'abilities',
      title: 'See everything Agent Hub can do',
      body: 'Explore every ability across the platform — then build your own ' +
        'agent from any of them in Studio.',
      placement: 'right',
    },
    {
      anchor: 'switch-app',
      title: 'Switch apps',
      body: 'Jump to Studio to build agents, or to the Admin portal for ' +
        'governance — whatever your access allows.',
      placement: 'right',
    },
    {
      anchor: 'send-feedback',
      title: 'Help shape the Hub',
      body: 'Spotted a bug or have an idea? Send it straight to the team — ' +
        'with the current chat attached if you like.',
      placement: 'right',
    },
    {
      anchor: 'profile',
      title: 'Usage & theme',
      body: 'Track your usage, flip light/dark theme, and log out from here.',
      placement: 'right',
    },
    {
      title: 'You’re all set 🎉',
      body: 'That’s the tour. Replay it anytime from What’s New — the sparkle ' +
        'button next to your profile.',
    },
  ],
};
